@for (message of messages(); track message.id) {
  <div
    class="message"
    [class.mb-0]="companionChat.chat.status === 'streaming' && $last"
    [class.left]="message.role === 'assistant'"
    [class.right]="message.role === 'user'"
    @messageAnimation
  >
    @if (message.role !== 'assistant') {
      @if (avatarUrl(); as url) {
        <img [src]="url" alt="user avatar" />
      } @else {
        <app-avatar-placeholder
          [initials]="getUserInitials()"
        ></app-avatar-placeholder>
      }
    }
    <div class="message-body">
      @for (part of message.parts; track $index) {
        @switch (part.type) {
          @case ('text') {
            @if (
              companionChat.parseMessagePart(part.text, 'file_name') !== ''
            ) {
              <ng-container
                *ngTemplateOutlet="
                  toolCallTemplate;
                  context: {
                    state: 'done',
                    content:
                      'company-tool.snippets.companion.tools.load-job-from-pdf.done'
                      | transloco
                        : {
                            fileName: companionChat.parseMessagePart(
                              part.text,
                              'file_name'
                            ),
                          },
                  }
                "
                @messageAnimation
              ></ng-container>
            }
            <div
              class="message-text"
              [innerHTML]="
                domSanitizer.bypassSecurityTrustHtml(
                  message.role === 'user'
                    ? companionChat.parseMessagePart(part.text)
                    : companionChat.parseMarkdown(part.text)
                )
              "
              (mouseup)="companionChat.handleMessageClick($event)"
            ></div>
          }
          @case ('tool-setPhase') {
            @switch (part.state) {
              @case ('input-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'pending',
                      content: part.input.phase,
                    }
                  "
                ></ng-container>
              }
              @case ('output-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'done',
                      content: part.output.phase,
                    }
                  "
                ></ng-container>
              }
              @case ('output-error') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'error',
                      content:
                        'company-tool.snippets.companion.tools.error'
                        | transloco: { phase: part.input.phase },
                    }
                  "
                ></ng-container>
              }
            }
          }
          @case ('tool-navigateToJobEditor') {
            @switch (part.state) {
              @case ('input-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'pending',
                      content:
                        'company-tool.snippets.companion.tools.navigate-to-job-editor.pending',
                    }
                  "
                ></ng-container>
              }
              @case ('output-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'done',
                      content:
                        part.output.navigated || part.output.alreadyOpen
                          ? 'company-tool.snippets.companion.tools.navigate-to-job-editor.done'
                          : part.output.blockedReason === 'unsaved_changes'
                            ? 'company-tool.snippets.companion.tools.navigate-to-job-editor.blocked-unsaved'
                            : 'company-tool.snippets.companion.tools.navigate-to-job-editor.error',
                    }
                  "
                ></ng-container>
              }
              @case ('output-error') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'error',
                      content:
                        'company-tool.snippets.companion.tools.navigate-to-job-editor.error',
                    }
                  "
                ></ng-container>
              }
            }
          }
          @case ('tool-getAvailableWorkLocations') {
            @switch (part.state) {
              @case ('input-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'pending',
                      content:
                        'company-tool.snippets.companion.tools.get-available-work-locations.pending',
                    }
                  "
                ></ng-container>
              }
              @case ('output-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'done',
                      content:
                        'company-tool.snippets.companion.tools.get-available-work-locations.done',
                    }
                  "
                ></ng-container>
              }
              @case ('output-error') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'error',
                      content:
                        'company-tool.snippets.companion.tools.get-available-work-locations.error',
                    }
                  "
                ></ng-container>
              }
            }
          }
          @case ('tool-generateJsonAnswer') {
            @switch (part.state) {
              @case ('input-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'pending',
                      content:
                        'company-tool.snippets.companion.tools.generate-json-answer.pending',
                    }
                  "
                ></ng-container>
              }
              @case ('output-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'done',
                      content:
                        'company-tool.snippets.companion.tools.generate-json-answer.done',
                    }
                  "
                ></ng-container>
              }
              @case ('output-error') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'error',
                      content:
                        'company-tool.snippets.companion.tools.generate-json-answer.error',
                    }
                  "
                ></ng-container>
              }
            }
          }
          @case ('tool-generateJobDescription') {
            @switch (part.state) {
              @case ('input-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'pending',
                      content:
                        'company-tool.snippets.companion.tools.generate-job-description.pending',
                    }
                  "
                ></ng-container>
              }
              @case ('output-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'done',
                      content:
                        'company-tool.snippets.companion.tools.generate-job-description.done',
                    }
                  "
                ></ng-container>
              }
              @case ('output-error') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'error',
                      content:
                        'company-tool.snippets.companion.tools.generate-job-description.error',
                    }
                  "
                ></ng-container>
              }
            }
          }
          @case ('tool-generateJobRedFlags') {
            @switch (part.state) {
              @case ('input-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'pending',
                      content:
                        'company-tool.snippets.companion.tools.generate-job-red-flags.pending',
                    }
                  "
                ></ng-container>
              }
              @case ('output-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'done',
                      content:
                        'company-tool.snippets.companion.tools.generate-job-red-flags.done',
                    }
                  "
                ></ng-container>
              }
              @case ('output-error') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'error',
                      content:
                        'company-tool.snippets.companion.tools.generate-job-red-flags.error',
                    }
                  "
                ></ng-container>
              }
            }
          }
          @case ('tool-searchSoftwareKnowledgeBase') {
            @switch (part.state) {
              @case ('input-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'pending',
                      content:
                        'company-tool.snippets.companion.tools.search-software-knowledge-base.pending',
                    }
                  "
                ></ng-container>
              }
              @case ('output-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'done',
                      content:
                        'company-tool.snippets.companion.tools.search-software-knowledge-base.done',
                    }
                  "
                ></ng-container>
              }
              @case ('output-error') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'error',
                      content:
                        'company-tool.snippets.companion.tools.search-software-knowledge-base.error',
                    }
                  "
                ></ng-container>
              }
            }
          }
          @case ('tool-getSourceCodeFromUrl') {
            @switch (part.state) {
              @case ('input-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'pending',
                      content:
                        'company-tool.snippets.companion.tools.get-source-code-from-url.pending',
                    }
                  "
                ></ng-container>
              }
              @case ('output-available') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'done',
                      content:
                        'company-tool.snippets.companion.tools.get-source-code-from-url.done',
                    }
                  "
                ></ng-container>
              }
              @case ('output-error') {
                <ng-container
                  *ngTemplateOutlet="
                    toolCallTemplate;
                    context: {
                      state: 'error',
                      content:
                        'company-tool.snippets.companion.tools.get-source-code-from-url.error',
                    }
                  "
                ></ng-container>
              }
            }
          }
        }
      }
    </div>
  </div>
}
@switch (companionChat.chat.status) {
  @case ('streaming') {
    <span class="typing-dot"></span>
  }
  @case ('submitted') {
    <div class="message left">
      <ng-lottie [options]="companionChat.loadingLottie"></ng-lottie>
    </div>
  }
}
@if (companionChat.errorWhileReplying()) {
  <div class="message message-error" [class.left]="true" @messageAnimation>
    <p>
      <span class="message-text">
        <fa-icon [icon]="fontawesomeService.light.exclamationCircle"></fa-icon>
        {{ 'company-tool.snippets.companion.message-error' | transloco }}
      </span>
    </p>
  </div>
}

<!-- Tool call template -->
<ng-template #toolCallTemplate let-state="state" let-content="content">
  @switch (state) {
    @case ('pending') {
      <span class="tool-call pending" @messageAnimation
        ><span
          ><!--<ct-lib-spinner></ct-lib-spinner>-->
          <fa-icon [icon]="fontawesomeService.light.sparkles"></fa-icon>
          {{ content | transloco }}</span
        ></span
      >
    }
    @case ('done') {
      <span class="tool-call done" @messageAnimation
        ><span
          ><fa-icon [icon]="fontawesomeService.light.check"></fa-icon>
          {{ content | transloco }}</span
        ></span
      >
    }
    @case ('error') {
      <span class="tool-call error" @messageAnimation
        ><span
          ><fa-icon
            [icon]="fontawesomeService.light.exclamationTriangle"
          ></fa-icon>
          {{ content | transloco }}</span
        ></span
      >
    }
  }
</ng-template>
